import { render, staticRenderFns } from "./viewProducts.vue?vue&type=template&id=9f077b94&"
import script from "./viewProducts.vue?vue&type=script&lang=js&"
export * from "./viewProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports